var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-start flex-column" },
    [
      _c("v-sheet", { staticClass: "d-inline-block text-truncate" }, [
        _vm.showLabel
          ? _c("span", { class: _vm.labelClass }, [
              _vm._v(
                " " +
                  _vm._s(_vm.label) +
                  " (" +
                  _vm._s(
                    _vm.companyLang
                      ? _vm.companyLang.filter(function (ele) {
                          return ele.is_default
                        })[0]["text"]
                      : null
                  ) +
                  ") "
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "v-input",
        {
          attrs: {
            messages: _vm.messages,
            success: _vm.success,
            "success-messages": _vm.successMsg,
            error: _vm.isError,
            "error-messages": _vm.errorMsg,
            "hide-details": false,
            "error-count": _vm.errorCount,
            hint: _vm.hint,
            dense: _vm.dense,
            "persistent-hint": _vm.persistentHint,
          },
        },
        [
          _c(
            "v-menu",
            {
              ref: "langmenu",
              staticClass: "rounded-lg",
              attrs: {
                color: "white",
                elevation: 4,
                "disable-keys": "",
                transition: "slide-y-transition",
                "close-on-content-click": false,
                "close-on-click": true,
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var attrs = ref.attrs
                    var on = ref.on
                    var value = ref.value
                    return [
                      !_vm.textArea
                        ? _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "text-field-width",
                                  attrs: {
                                    dense: _vm.dense,
                                    height: _vm.height,
                                    rules: _vm.canFocus ? _vm.rules : [],
                                    filled: _vm.readonly ? false : _vm.filled,
                                    "single-line": _vm.singleLine,
                                    "hide-details": _vm.hideDetails,
                                    error: _vm.isError,
                                    disabled: _vm.disabled,
                                    readonly: true,
                                    "append-icon": _vm.appendIcon,
                                    "prepend-icon": _vm.prependIcon,
                                  },
                                  on: {
                                    focus: _vm.onFocus,
                                    keydown: function ($event) {
                                      return _vm.onKeyDown(_vm.defaultKey)
                                    },
                                    "update:error": _vm.onError,
                                    "click:append": function ($event) {
                                      return _vm.$emit("appendClick")
                                    },
                                    "click:prepend": function ($event) {
                                      return _vm.$emit("prependClick")
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                ref: "langu",
                                                                style: {
                                                                  marginTop:
                                                                    _vm.readonly
                                                                      ? "0px"
                                                                      : "3px",
                                                                  right:
                                                                    _vm.readonly
                                                                      ? "0px"
                                                                      : "-12px",
                                                                },
                                                                attrs: {
                                                                  icon: "",
                                                                  small:
                                                                    _vm.readonly,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.showMenu = true
                                                                    },
                                                                },
                                                              },
                                                              _vm.showMenu
                                                                ? null
                                                                : on
                                                            ),
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons-round",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.appendIcon
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message_essweb_language_components_earthTip"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.defaultValue,
                                    callback: function ($$v) {
                                      _vm.defaultValue = $$v
                                    },
                                    expression: "defaultValue",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              _vm.readonly ? null : on
                            )
                          )
                        : _vm._e(),
                      _vm.textArea
                        ? _c(
                            "v-textarea",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "text-field-width",
                                  attrs: {
                                    rows: "3",
                                    "no-resize": "",
                                    dense: _vm.dense,
                                    rules: _vm.canFocus ? _vm.rules : [],
                                    filled: _vm.readonly ? false : _vm.filled,
                                    "single-line": _vm.singleLine,
                                    "hide-details": _vm.hideDetails,
                                    error: _vm.isError,
                                    disabled: _vm.disabled,
                                    readonly: true,
                                    maxlength: "150",
                                    counter: "150",
                                    "append-icon": _vm.appendIcon,
                                    "prepend-icon": _vm.prependIcon,
                                  },
                                  on: {
                                    focus: _vm.onFocus,
                                    keydown: function ($event) {
                                      return _vm.onKeyDown(_vm.defaultKey)
                                    },
                                    "click:append": function ($event) {
                                      return _vm.$emit("appendClick")
                                    },
                                    "click:prepend": function ($event) {
                                      return _vm.$emit("prependClick")
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              {
                                                                ref: "langu2",
                                                                style: {
                                                                  marginTop:
                                                                    _vm.readonly
                                                                      ? "0px"
                                                                      : "3px",
                                                                  right:
                                                                    _vm.readonly
                                                                      ? "0px"
                                                                      : "-12px",
                                                                },
                                                                attrs: {
                                                                  icon: "",
                                                                  small:
                                                                    _vm.readonly,
                                                                  disabled:
                                                                    _vm.ban,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.showMenu = true
                                                                    },
                                                                },
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons-round",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.appendIcon
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "Multi-Language supported"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.defaultValue,
                                    callback: function ($$v) {
                                      _vm.defaultValue = $$v
                                    },
                                    expression: "defaultValue",
                                  },
                                },
                                "v-textarea",
                                attrs,
                                false
                              ),
                              _vm.readonly ? null : on
                            )
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.showMenu,
                callback: function ($$v) {
                  _vm.showMenu = $$v
                },
                expression: "showMenu",
              },
            },
            [
              _c(
                "v-container",
                { staticClass: "white rounded-lg pa-3", attrs: { fluid: "" } },
                [
                  _vm._l(_vm.companyLang, function (item, index) {
                    return [
                      _c(
                        "v-sheet",
                        { key: "language" + index },
                        [
                          _c("v-sheet", [
                            _c(
                              "span",
                              {
                                staticClass: "text--secondary",
                                class: _vm.isRequire ? "mrc_text_require" : "",
                              },
                              [_vm._v(" " + _vm._s(item["text"]) + " ")]
                            ),
                          ]),
                          !_vm.textArea
                            ? _c("v-text-field", {
                                staticClass: "text-field-width",
                                attrs: {
                                  autofocus:
                                    index == 0 && !_vm.readonly ? true : false,
                                  hint: _vm.hint,
                                  height: _vm.height,
                                  maxlength: _vm.maxlength,
                                  rules: _vm.canFocus ? _vm.rules : [],
                                  readonly: _vm.readonly,
                                  filled: _vm.readonly ? false : _vm.filled,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.placeholder,
                                  "single-line": _vm.singleLine,
                                  "persistent-hint": _vm.persistentHint,
                                  clearable: _vm.clearable,
                                  loading: _vm.loading,
                                  flat: _vm.flat,
                                  dense: _vm.dense,
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  change: _vm.valueChange,
                                  keydown: function ($event) {
                                    return _vm.onKeyDown(item["value"])
                                  },
                                },
                                model: {
                                  value: _vm.valueArr[item["value"]],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.valueArr, item["value"], $$v)
                                  },
                                  expression: "valueArr[item['value']]",
                                },
                              })
                            : _vm._e(),
                          _vm.textArea
                            ? _c("v-textarea", {
                                staticClass: "text-field-width",
                                attrs: {
                                  rows: "3",
                                  "no-resize": "",
                                  autofocus:
                                    index == 0 && !_vm.readonly ? true : false,
                                  hint: _vm.hint,
                                  maxlength: _vm.maxlength,
                                  counter: _vm.maxlength,
                                  rules: _vm.canFocus ? _vm.rules : [],
                                  readonly: _vm.readonly,
                                  filled: _vm.readonly ? false : _vm.filled,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.placeholder,
                                  "single-line": _vm.singleLine,
                                  "persistent-hint": _vm.persistentHint,
                                  clearable: _vm.clearable,
                                  loading: _vm.loading,
                                  flat: _vm.flat,
                                  dense: _vm.dense,
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  change: _vm.valueChange,
                                  keydown: function ($event) {
                                    return _vm.onKeyDown(item["value"])
                                  },
                                },
                                model: {
                                  value: _vm.valueArr[item["value"]],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.valueArr, item["value"], $$v)
                                  },
                                  expression: "valueArr[item['value']]",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  }),
                  !_vm.readonly
                    ? _c(
                        "v-container",
                        {
                          staticClass: "d-flex pa-3 pt-6 pb-6",
                          attrs: { fluid: "" },
                        },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-button mr-2",
                              attrs: {
                                text: "",
                                small: "",
                                color: "primary",
                                ripple: false,
                                rounded: "",
                                height: "34",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.handClose = true
                                  _vm.onCancel()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_form_tools_cancelBtnLabel"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-button pr-6 pl-6",
                              attrs: {
                                rounded: "",
                                small: "",
                                height: "34",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.handClose = true
                                  _vm.onConfirm()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("label_essweb_form_tools_oKBtnLabel")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }